import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            按类型探索你感兴趣的同人创作，发现更多精彩作品
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200 cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={cat.name}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <div className="flex items-center gap-2 mb-1">
                  <span className="w-6 h-6 flex items-center justify-center">
                    <i className={`${cat.icon} text-white text-sm`}></i>
                  </span>
                  <h3 className="text-base font-heading font-bold text-white">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-white/75 line-clamp-1">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}